// extracted by mini-css-extract-plugin
export default {"header":"Header_header__2aZK3","main-image":"Header_main-image__Q0VZI"};